import { Path } from 'config/constants/paths'
import { useTranslation } from 'contexts/Localization'
import React from 'react'
import { Modal, Text, Flex, Button, InjectedModalProps, Box } from 'vvs-uikit'
import history from 'routerHistory'

const PreventWithDrawModal: React.FC<InjectedModalProps> = ({ onDismiss }) => {
  const { t } = useTranslation()
  return (
    <Modal title={t('Unstake NFTs before withdrawal')} bodyPadding="0 24px 24px" onDismiss={onDismiss}>
      <Box>
        <Flex maxWidth="430px" justifyContent="center" alignItems="center" gap="24px" flexDirection="column">
          <Text fontSize="20px" textAlign="center" color="textSubtle">
            {t(
              'Withdrawal from all your xVVS vaults will remove your boosted rewards from your farms.  Please unstake your NFTs from boosted farms before performing all xVVS vault withdrawal',
            )}
          </Text>
          <Flex flex={1} width="100%" flexDirection="column" gap="12px">
            <Button
              width="100%"
              variant="primary"
              onClick={() => {
                onDismiss()
                history.push(Path.VVS_FARM)
              }}
            >
              {t('Unstake NFTs from Farms')}
            </Button>
            <Button width="100%" variant="secondary" onClick={onDismiss}>
              {t('Cancel')}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Modal>
  )
}

export default PreventWithDrawModal
